export default {
  title: 'Please select onboarding induction page and questionnaire',
  label: {
    inductionPage: 'Induction Page',
    questionnaire: 'Questionnaire',
    onboardDate: 'Onboard Date',
    notificationEmail: 'Notification Email',
    onboardingInvited: 'Onboarding Form Invited'
  },
  btn: {
    addEmail: 'Add Email'
  },
  message: {
    atLeastOneInductionPageOrQuestionnaire: 'Please select at least one induction page or one questionnaire',
    inviteSuccess: 'Invite Success',
    hasInvited: 'Invited or previously completed once onboarding',
    inviteFail: 'Invite Failed'
  }
}
